export const Advisory = 'Advisory/';

export const AdvisoryEmployees = Advisory +'Employee/';
export const AdvisoryClient = Advisory + 'Client';
export const AdvisoryRegistrations = Advisory + 'ClientRegistration/';
export const AdvisoryScorecards = Advisory + 'ClientScorecard/';

export const GetLinkedBEE123Employees = AdvisoryEmployees + 'GetLinkedBEE123Employees';
export const CreateScorecardReport = AdvisoryEmployees + 'CreateReport';

export const SearchClientRegistrations = AdvisoryRegistrations + 'SearchClientRegistrations';
export const SearchScorecardReports = AdvisoryEmployees + 'SearchScorecardReports';
export const SearchClientScorecards = AdvisoryScorecards + 'SearchClientScorecards';
